// Client-side app version. Separate from `app_versions` DB table — that
// drives the WhatsNew changelog modal. This is the build-stamp shown in
// the About block and anywhere else we need a single source of truth.
export const APP_VERSION = '1.4.0'
